import { DropdownTrigger } from '../DropdownTrigger/DropdownTrigger'
import Styles from './EmojiPicker.module.scss'
import AddEmoji from 'almanac-ui/icons/16/AddEmoji'
import { DocEmoji } from '../DocEmoji/DocEmoji'
import { BaseEmoji } from 'types'
import { FileEmojiPicker } from 'components/FileEmojiPicker/FileEmojiPicker'
import { useRootStore } from 'stores/RootStore'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { observer } from 'mobx-react-lite'
import { Picker } from 'components/AlmanacFileTitle/Picker'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { Icon } from 'almanac-ui/icons/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignChannel as NewFileModalDesignChannel } from 'components/NewFileModal/Types'

interface Props extends Pick<ButtonProps, 'size' | 'variant'> {
  emoji: string | null
  onSelect: (emoji: BaseEmoji | null) => void
  defaultIcon?: Icon
  buttonClass?: string
  fileKey?: string
  withChannels?: boolean
}

const EmojiIcon = ({
  channelEmoji,
  emoji,
  defaultIcon: DefaultIcon = AddEmoji,
}: {
  emoji: string | null
  defaultIcon?: Icon
  channelEmoji?: ChannelType | NewFileModalDesignChannel | null
}) => {
  if (channelEmoji) {
    return <ChannelIcon channel={channelEmoji} />
  }

  if (emoji) {
    return <DocEmoji emoji={emoji} />
  }

  return <DefaultIcon />
}

export const EmojiPicker = observer(
  ({
    emoji,
    onSelect,
    size = 'md',
    variant = 'secondary',
    defaultIcon = AddEmoji,
    buttonClass,
    fileKey,
    withChannels = false,
  }: Props) => {
    const rootStore = useRootStore()
    const file = rootStore.files.get(fileKey || '')

    return (
      <DropdownTrigger popoverClassName={Styles.popOver}>
        <IconButton
          size={size}
          variant={variant}
          aria-label="Emoji"
          icon={() => <EmojiIcon channelEmoji={file?.channel_emoji} emoji={emoji} defaultIcon={defaultIcon} />}
        />
        {(close) => (
          <div className={Styles.pickerContainer}>
            {fileKey ? (
              <FileEmojiPicker
                fileKey={fileKey}
                withChannels={withChannels}
                onSelect={async (emoji: BaseEmoji | null) => {
                  onSelect(emoji)
                  close()
                }}
              />
            ) : (
              <Picker
                autoFocus
                theme="light"
                previewPosition="none"
                onEmojiSelect={async (emoji: BaseEmoji | null) => {
                  onSelect(emoji)
                  close()
                }}
              />
            )}
          </div>
        )}
      </DropdownTrigger>
    )
  },
)
